import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import Navbar from "../../../atoms/navbar";

import {
    Layout,
    Alert,
    Collapse,
    Form,
    AutoComplete,
    Input,
    Row,
    Col,
    Select,
    Checkbox,
    Button,
    message,
    Radio,
    Modal,
    Table,
    Upload,
    List,
    Tag,
} from "antd";
import { Block, Confirm, Loading, Report } from "notiflix";
import { UploadOutlined } from '@ant-design/icons';
import { use } from "react";
import { QuestionOutlined, DeleteOutlined, ReloadOutlined } from "@ant-design/icons";
import API from "../../../services";
import HeaderFarms from "../../../utils/header_farms";
import { loginRequest } from "../../../config/api.config";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { get, set } from "react-hook-form";
import moment from "moment";

export default function SapViewBidding() {
    const [form] = Form.useForm();
    const [items, setItems] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [selectedRowKey, setSelectedRowKey] = useState(null);
    const [vendorNotes, setVendorNotes] = useState({});
    const [hasInitialized, setHasInitialized] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [NewVendorName, setNewVendorName] = useState('');
    const [NewQuotationNumber, setNewQuotationNumber] = useState('');
    const [vendorSelected, setVendorSelected] = useState([]);
    const [biddingHdr, setBiddingHdr] = useState([]);
    const [approvalStatus, setApprovalStatus] = useState([]);
    const [approvalUser, setApprovalUser] = useState([]);
    const [userBranch, setUserBranch] = useState([]);
    const [comments, setComments] = useState([]);
    const { instance, accounts } = useMsal();
    const [comment, setComment] = useState('');
    const [fileList, setFileList] = useState({});
    const [vendorErp, setVendorErp] = useState([]);
    const [isCommentModalOpen, setIsCommentModalOpen] = useState(false);
    const [isCommentModalReject, setIsCommentModalReject] = useState(false);
    const [isButtonShow, setIsButtonShow] = useState(false);
    const [idRecord, setIdRecord] = useState('');
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [formVendor] = Form.useForm();
    const [currentSession, setCurrentSession] = useState(
        JSON.parse(localStorage.getItem("session_signin"))
    );
    const isAuthenticated = useIsAuthenticated();

    const navigate = useNavigate();

    const { id } = useParams();

    const inisialVendors = []
    const InitialBiddingHdr = {
        description: "",
        req_num: "",
        selectedVendor: "",
        vendorValue: "",
        buyer_id: "",
        buyer_name: "",
        additional_information: "",
    }

    const columns = [
        {
            title: "Vendor Name",
            dataIndex: "vendor_name",
        },
        {
            title: "Quotation Number",
            dataIndex: "quotation_number",
        },
        {
            title: "Price",
            dataIndex: "price",
            align: "right",
            render: (value) => {
                return new Intl.NumberFormat("id-ID").format(value || 0)
            }
        },
        {
            title: "Keterangan",
            render: (_, record, index) => {
                return (
                    <Input
                        disabled={true}
                        placeholder=""
                        value={record.vendorNotes}
                    />
                );
            },
        }
    ];

    const showModal = () => {
        setIsCommentModalOpen(true);
    };

    const showModelReject = () => {
        setIsCommentModalReject(true);
    }

    const onClickApprove = async () => {
        try {
            Loading.standard("Approving bidding...");
            const request = {
                ...loginRequest,
                account: accounts[0],
            };
            const responseToken = await instance.acquireTokenSilent(request).catch(e => {
                console.error("Token acquisition failed", e);
                throw e;
            });
            const accessToken = responseToken.accessToken;

            const headers = HeaderFarms(accessToken);
            for (const detail of approvalStatus) {
                if (detail.approver_id === currentSession.nik) {
                    const data = {
                        id: detail._id,
                        status: false,
                    };

                    console.log("Approval Data:", data);

                    const response = await API.ApprovalApproved(headers, data);
                    if (response.code === 200) {
                        Loading.remove();
                        message.success("Bidding approved successfully");
                        navigate("/sapbdng/history");
                    } else {
                        Loading.remove();
                        console.log("response approval");
                        message.error("Failed to approve bidding: " + response.error);
                    }
                }
            }
            // Refresh the bidding data to show the new status
            getBidding();
            Loading.remove();
        }
        catch (error) {
            console.error(error);
            Loading.remove();
        }
    }

    const onClickReject = async () => {
        try {
            Loading.standard("Approving bidding...");
            const request = {
                ...loginRequest,
                account: accounts[0],
            };
            const responseToken = await instance.acquireTokenSilent(request).catch(e => {
                console.error("Token acquisition failed", e);
                throw e;
            });
            const accessToken = responseToken.accessToken;

            const headers = HeaderFarms(accessToken);
            for (const detail of approvalStatus) {
                if (detail.approver_id === currentSession.nik) {
                    const data = {
                        id: detail._id,
                        reason : comment,
                    };

                    console.log("Approval Data:", data);

                    const response = await API.ApprovalReject(headers, data);
                    if (response.code === 200) {
                        Loading.remove();
                        message.success("Bidding rejected successfully");
                        navigate("/sapbdng/history");
                    } else {
                        Loading.remove();
                        console.log("response approval");
                        message.error("Failed to reject bidding: " + response.error);
                    }
                }
            }
            // Refresh the bidding data to show the new status
            getBidding();
            Loading.remove();
        }
        catch (error) {
            console.error(error);
            Loading.remove();
        }
    }

    const handleOk = async () => {
        console.log("Comment:", comment);
        try {
            const request = {
                ...loginRequest,
                account: accounts[0],
            };
            const responseToken = await instance.acquireTokenSilent(request).catch(e => {
                console.error("Token acquisition failed", e);
                throw e;
            });
            const accessToken = responseToken.accessToken;

            const headers = HeaderFarms(accessToken);
            const data = {
                record_id: id,
                comment: comment,
                commented_by: currentSession ? currentSession.fullname : "Unknown User",
            };
            await API.sapAddCommentBidding(headers, data);
            getBidding(); // Refresh the bidding data to show the new comment
        }
        catch (error) {
            console.error(error);
        }
        setIsCommentModalOpen(false);
    };

    const handleCancel = () => {
        setIsCommentModalOpen(false);
    };

    const handleOkReject = async () => {
        handleOk();
        onClickReject();
    }

    const handleCancelReject = () => {
        setIsCommentModalReject(false);
    };

    const getBidding = async () => {
        try {
            const request = {
                ...loginRequest,
                account: accounts[0],
            };
            const responseToken = await instance.acquireTokenSilent(request).catch(e => {
                console.error("Token acquisition failed", e);
                throw e;
            });
            const accessToken = responseToken.accessToken;

            const headers = HeaderFarms(accessToken);
            const response = await API.getBidding(headers, id);
            setBiddingHdr(response.data);
            setVendors(response.data.vendor);
            setComments(response.data.comments || []);

            const selectedVendor = response.data.vendor.find(v => v.selected);

            setVendorSelected(selectedVendor?.vendor_name || '');

            const approvalDetail = response.data.approval_detail || [];
            const approvalUsers = response.data.approver_users || [];

            const userMap = new Map(
                approvalUsers.map(user => [user.nik, user])
            );

            const mergedApproval = approvalDetail.map(detail => {
                const user = userMap.get(detail.approver_id);

                return {
                    ...detail,
                    fullname: user?.fullname || null
                };
            });

            setApprovalStatus(mergedApproval);

            // Cek Button Show/Hide

            approvalDetail.forEach(detail => {
                if (detail.approver_id === currentSession.nik && detail.status === false && detail.rejected === false) {
                    setIsButtonShow(true);
                }
            })

            const selectedIndexes = response.data.vendor
                .map((item, index) => item.selected ? index : null)
                .filter(index => index !== null);

            setSelectedRowKeys(selectedIndexes);


        }
        catch (error) {
            console.error(error);
        }
    }
    function RequestToken() {
        const request = {
            ...loginRequest,
            account: accounts[0],
        };

        instance
            .acquireTokenSilent(request)
            .then((response) => {
                if (!currentSession) {
                    getUser(response.accessToken);
                }

            })
            .catch((e) => {
                handleLogin(instance);
                console.error(e);
            });
    }

    function handleLogin(instance) {
        instance
            .loginRedirect(loginRequest)
            .then(() => { })
            .catch((e) => {
                console.error(e);
            });
    }

    async function getUser(token) {
        try {
            const user = await API.getUserCredential(HeaderFarms(token), {
                access_token: token,
            });
            setCurrentSession(user);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        if (!isAuthenticated) {
            RequestToken();
        } else {
            if (instance.getAllAccounts().length > 0) {
                instance.setActiveAccount(accounts[0]);
                RequestToken();

            } else {
                handleLogin(instance);
            }
        }
    })

    useEffect(() => {
        getBidding();
    }, [id]);

    useEffect(() => {
        if (biddingHdr) {
            form.setFieldsValue({
                department: biddingHdr.department || "",
                rfqLink: biddingHdr.rfq_link || "",
                rfqNum: biddingHdr.rfq_num || "",
                additional_information: biddingHdr.additional_notes || "",
                vender_recommendation: vendorSelected || "",
            });
        }
    }, [biddingHdr, vendorSelected]);

    useEffect(() => {
        if (hasInitialized) return;
        // 🔥 Dummy Form Values
        getBidding();


        // 🔥 Vendor terpilih (radio)
        setSelectedRowKey(1); // PT Beta Solusi (termurah)

        // 🔥 Keterangan vendor terpilih
        setVendorNotes({
            1: "Harga paling murah dan estimasi pengiriman cepat",
        });

        setHasInitialized(true);
    }, [form, hasInitialized]);

    const { Panel } = Collapse;
    const { TextArea } = Input
    const { Option } = Select;
    return (
        <>
            <Navbar
                title="Create"
                back={true}
                subtitle="Bidding"
                navigate="/sapbdng/history"
            />
            <div className="container-fluid white-back-cr">
                <Form
                    form={form}
                    scrollToFirstError={true}
                    name="service_request_form"
                    encType="multipart/form-data"
                    autoComplete="off"
                    size="middle"
                    layout="vertical"

                >
                    <div className="container p-3" style={{ alignSelf: "center" }}>
                        <div className="row">
                            <div className="col-md-12">
                                <Collapse
                                    className="collapse_sr"
                                    expandIconPosition={"end"}
                                    bordered={true}
                                    defaultActiveKey={["0", "1", "2", "3", "4", "5"]}
                                >
                                    <Panel
                                        style={{ background: "#fce8b6" }}
                                        header={<b>Summary</b>}
                                        key="1"
                                    >
                                        <List.Item>
                                            <List.Item.Meta
                                                title={
                                                    <div style={{ fontWeight: "bold" }}>
                                                        Bidding Number
                                                    </div>
                                                }
                                                description={biddingHdr.record_id}
                                            />
                                        </List.Item>
                                        <List.Item>
                                            <List.Item.Meta
                                                title={
                                                    <div style={{ fontWeight: "bold" }}>
                                                        Create Date
                                                    </div>
                                                }
                                                description={moment(biddingHdr.created_at).format("DD-MM-YYYY")}
                                            />
                                        </List.Item>
                                        <List.Item>
                                            <List.Item.Meta
                                                title={
                                                    <div style={{ fontWeight: "bold" }}>
                                                        Create By
                                                    </div>
                                                }
                                                description={biddingHdr.buyer_name}
                                            />
                                        </List.Item>
                                        <br />
                                        <Row gutter={10} className="mb-1">
                                            <Col xs={{ span: 24 }} sm={{ span: 7 }} xl={{ span: 7 }}>
                                                <Form.Item
                                                    label="Department"
                                                    name="department"
                                                    rules={[
                                                        { required: true, message: "Please input Department" },
                                                    ]}
                                                >
                                                    <Input disabled />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={{ span: 24 }} sm={{ span: 7 }} xl={{ span: 7 }}>
                                                <Form.Item
                                                    label="RFQ Num"
                                                    name="rfqNum"
                                                    rules={[
                                                        { required: true, message: "Please input RFQ Number" },
                                                    ]}
                                                >
                                                    <Input disabled
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={{ span: 24 }} sm={{ span: 7 }} xl={{ span: 7 }}>
                                                <Form.Item
                                                    label="RFQ Link"
                                                    name="rfqLink"
                                                    rules={[
                                                        { required: true, message: "Please input RFQ Number" },
                                                    ]}
                                                >
                                                    <a
                                                        href={form.getFieldValue("rfqLink")}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {form.getFieldValue("rfqLink")}
                                                    </a>
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Panel>
                                    <Panel
                                        style={{ background: "#fce8b6" }}
                                        header={<b>Vendor</b>}
                                        key="1"
                                    >
                                        <Table
                                            dataSource={vendors}
                                            rowKey={(record, index) => index}
                                            pagination={false}
                                            columns={columns}
                                        />


                                    </Panel>
                                    <Panel
                                        style={{ background: "#fce8b6" }}
                                        header={<b>Additional Information</b>}
                                        key="1"
                                    >
                                        <Row gutter={10} className="mb-1">
                                            <Col xs={{ span: 24 }} sm={{ span: 7 }} xl={{ span: 7 }} >
                                                <Form.Item
                                                    label="Vendor Recommendation"
                                                    name="vender_recommendation"
                                                    rules={[
                                                        { required: true },
                                                    ]}
                                                >
                                                    <Input disabled
                                                    />
                                                </Form.Item>
                                            </Col >
                                            <Col xs={{ span: 24 }} sm={{ span: 7 }} xl={{ span: 7 }} >
                                                <Form.Item
                                                    label="Additional Information"
                                                    name="additional_information"
                                                    rules={[
                                                        { required: true, message: "Please input Additional Information" },
                                                    ]}
                                                >
                                                    <Input.TextArea
                                                        rows={4}
                                                        placeholder="Input Additional Information"
                                                        disabled
                                                    />
                                                </Form.Item>
                                            </Col >
                                            <Col xs={{ span: 24 }} sm={{ span: 7 }} xl={{ span: 7 }}>
                                                {/* <Form.Item
                                                    label="File Attachment"
                                                    name="attachment"
                                                    valuePropName="fileList"
                                                    getValueFromEvent={e => Array.isArray(e) ? e : e && e.fileList}
                                                    rules={[{ message: "Please upload a file" }]}
                                                >
                                                    <Upload beforeUpload={() => false} multiple>
                                                        <Button icon={<UploadOutlined />}>Click to Upload</Button>
                                                    </Upload>
                                                </Form.Item> */}
                                            </Col>
                                        </Row>
                                    </Panel>
                                    <Panel
                                        style={{ background: "#fce8b6" }}
                                        header={<b>Comments</b>}
                                        key="1"
                                    >
                                        <List
                                            itemLayout="vertical"
                                            dataSource={comments}
                                            renderItem={(item) => (
                                                <List.Item>
                                                    <List.Item.Meta
                                                        title={
                                                            <div style={{ fontWeight: "bold" }}>
                                                                {item.commented_by}
                                                            </div>
                                                        }
                                                        description={moment(item.commented_at).format("DD-MM-YYYY")}
                                                    />
                                                    <div>{item.comment}</div>
                                                </List.Item>
                                            )}
                                        />
                                    </Panel>
                                    <Panel
                                        style={{ background: "#fce8b6" }}
                                        header={<b>Approval Status</b>}
                                        key="1"
                                    >
                                        <List
                                            itemLayout="horizontal"
                                            dataSource={approvalStatus}
                                            renderItem={(item) => (
                                                <List.Item
                                                    extra={
                                                        item.status == true ? (
                                                            <Tag color="green">APPROVED</Tag>
                                                        ) : item.rejected == true ? (
                                                            <Tag color="red">REJECTED</Tag>
                                                        ) : (
                                                            <Tag color="orange">PENDING</Tag>
                                                        )
                                                    }
                                                >
                                                    <List.Item.Meta
                                                        title={<b>{item.fullname} ({item.approver_id})</b>}
                                                        description={
                                                            item.status == true
                                                                ? `Approved at ${item.updatedAt}`
                                                                : item.rejected == true ? `Rejected at ${item.updatedAt}` : "Waiting for approval"
                                                        }
                                                    />
                                                </List.Item>
                                            )}
                                        />
                                    </Panel>
                                </Collapse>
                                <div style={{ display: 'flex', justifyContent: 'center', gap: "30px" }}>
                                    <Button
                                        type="primary"
                                        style={{ width: "200px" }}
                                        hidden={!isButtonShow}
                                        onClick={onClickApprove}
                                    >
                                        Approve
                                    </Button>

                                    <Button
                                        danger
                                        style={{ width: "200px" }}
                                        hidden={!isButtonShow}
                                        onClick={showModelReject}
                                    >
                                        Reject
                                    </Button>
                                    <Button
                                        type="primary"
                                        style={{ width: "200px" }}
                                        onClick={showModal}
                                        hidden={!isButtonShow}
                                    >
                                        comment
                                    </Button>
                                    <Modal
                                        title="Add Comment"
                                        open={isCommentModalOpen}
                                        onOk={handleOk}
                                        onCancel={handleCancel}
                                        okText="Submit"
                                        cancelText="Cancel"
                                    >
                                        <TextArea
                                            rows={4}
                                            placeholder="Write your comment here..."
                                            value={comment}
                                            onChange={(e) => setComment(e.target.value)}
                                        />
                                    </Modal>

                                    <Modal
                                        title="Add Comment Reject"
                                        open={isCommentModalReject}
                                        onOk={handleOkReject}
                                        onCancel={handleCancelReject}
                                        okText="Submit"
                                        cancelText="Cancel"
                                    >
                                        <TextArea
                                            rows={4}
                                            placeholder="Write your comment here..."
                                            value={comment}
                                            onChange={(e) => setComment(e.target.value)}
                                        />
                                    </Modal>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        </>
    );
}
